import BackendClient from '../backend-client';
import Cache, { modelFactory } from './model';

export default class CacheClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  send = async (method) => {
    const response = await this.request('get', `reset/${method}`)();
    return this.format(response);
  }
}

export {
  Cache,
};
